/**
 * Where this code runs. The embeddable widget (`widget.iife.js`) shares the
 * API client with the admin app, but on a customer's website there is no
 * admin session: a 401 there must never refresh an admin token, clear
 * storage or send the visitor to `/login` — that is the host site's page.
 * The widget entry marks the bundle as embedded before anything else runs.
 */
let embedded = false;

/** Called once by the widget entry (`widget-entry.ts`). */
export function markEmbeddedWidget(): void {
  embedded = true;
}

/** True inside the embedded widget bundle, on any host page. */
export function isEmbeddedWidget(): boolean {
  return embedded;
}
